// extracted by mini-css-extract-plugin
module.exports = {"field":"SkeletonInput_field__32ADI","label":"SkeletonInput_label__wfkyf"};